import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Button } from '@/common/components/Button/Button';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { RouterLink } from '@/common/components/RouterLink/RouterLink.web';
import { Stack } from '@/common/components/Stack/Stack';
import { Translate } from '@/common/components/Translate/Translate';
import { ROUTES } from '@/common/constants/routes';
import { IlustrationStep1 } from '@/common/containers/Dashboard/ITMealVoucherLearningCenter/IlustrationStep1';
import { IlustrationStep2 } from '@/common/containers/Dashboard/ITMealVoucherLearningCenter/IlustrationStep2';
import { IlustrationStep3 } from '@/common/containers/Dashboard/ITMealVoucherLearningCenter/IlustrationStep3';

export interface IITMealVoucherLearningCenterProps {
  onClose: () => void;
}

export const ITMealVoucherLearningCenter = ({
  onClose,
}: IITMealVoucherLearningCenterProps) => {
  const { t } = useTranslation();

  return (
    <ModalLearning.Root onClose={onClose} heightClass="h-[50rem]">
      <ModalLearning.Step
        title={t(
          'dashboard.meal_voucher.learning_centre.what_are_meal_vouchers.title'
        )}
        description={
          <BodyText>
            <Translate i18nKey="dashboard.meal_voucher.learning_centre.what_are_meal_vouchers.content" />
          </BodyText>
        }
        asset={<IlustrationStep1 />}
      />
      <ModalLearning.Step
        title={t(
          'dashboard.meal_voucher.learning_centre.how_to_use_meal_vouchers.title'
        )}
        description={
          <BodyText>
            <Translate
              i18nKey={
                'dashboard.meal_voucher.learning_centre.how_to_use_meal_vouchers.content'
              }
            />
          </BodyText>
        }
        asset={<IlustrationStep2 />}
      />
      <ModalLearning.Step
        title={t(
          'dashboard.meal_voucher.learning_centre.where_to_use_meal_vouchers.title'
        )}
        description={
          <Stack gap="lg">
            <Stack>
              <BodyText>
                <Translate i18nKey="dashboard.meal_voucher.learning_centre.network_content" />
              </BodyText>
              <RouterLink href={ROUTES.MEAL_NETWORK}>
                <Button variant="tertiary" presentational>
                  {t('dashboard.meal_voucher.network_btn')}
                </Button>
              </RouterLink>
            </Stack>
          </Stack>
        }
        asset={<IlustrationStep3 />}
      />
    </ModalLearning.Root>
  );
};
